import { Injectable } from '@angular/core';
import { Vector3 } from 'babylonjs';
import { ArcRotateCamera } from 'babylonjs/Cameras/arcRotateCamera';
import { LAYER_TYPES } from '@App/app/entities/layer/enums/layer-types.enum';
import { SceneService } from '../../scene-service/scene.service';
import { BasePlaneService } from '../base-plane-services/base-plane.service';

@Injectable({
  providedIn: 'root',
})
export class ViewerLayerCameraService {
  constructor(private sceneService: SceneService, private basePlaneService: BasePlaneService) {}

  setCameraOnLayerTarget(
    targetData: { center: Vector3; radius: number },
    layerType: LAYER_TYPES,
  ): void {
    const camera = this.sceneService.scene.activeCamera as ArcRotateCamera;
    const { center, radius } = targetData;
    camera.target = center;
    if (layerType === LAYER_TYPES.BASE_PLANE) {
      camera.radius = radius;
    } else {
      const cameraPositionModifier = this.basePlaneService.getBasePlanesPosition();
      cameraPositionModifier.y = center.y;
      const normal = center.subtract(cameraPositionModifier).normalize();
      const cameraPosition = center.add(normal.scale(radius));
      camera.position = cameraPosition;
    }
  }
}
